export const city = {
    /**
    * Gets the programmatic name of the entire locale, with the language, 
    *   country and variant separated by underbars. The Language is always lower case, 
    *   and country is always upper case. If the language is missing, 
    *   the string will begin with an underscore character. 
    *   If both the language and country fields are missing, 
    *   this function will return the empty string, 
    *   even if the variant field is filled in (you cannot have a locale with just a variant-- 
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
    en: {
        city:'City',
        city_id:'City Id',
        city_management:'City Management',
        add_city:'Add City',
        edit_city:'Edit City',
        cancel:'cancel',
        submit:'submit',
        city_information:'City Information',
        city_name:'City Name',
        state:'State',
        city_status:'City Status',
        country_name:'Country Name',
        state_name:'State Name',
        delete_confrim_msg:"Are you sure you want to delete this city list?",
    },

    ar: {
        city:'مدينة',
        city_id:'معرف المدينة',
        city_management:'إدارة المدينة',
        add_city:'أضف مدينة',
        edit_city:'تحرير المدينة',
        cancel:'إلغاء',
        submit:'إرسال',
        city_information:'معلومات المدينة',
        city_name:'اسم المدينة',
        state:'حالة',
        city_status:'حالة المدينة',
        country_name:'اسم الدولة',
        state_name:'اسم الولاية',
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف قائمة المدن هذه؟"
    }
}